module.exports = __webpack_public_path__ + "static/media/AestheticsM.f3bdb6ba.png";